import React, { useEffect } from "react";

const ElfsightGallery = () => {
  useEffect(() => {
    const scriptId = "elfsight-platform-script";

    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.src = "https://static.elfsight.com/platform/platform.js";
      script.id = scriptId;
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <>
      {/* Elfsight Photo Gallery | Flipkart Connect */}
      <div
        className="elfsight-app-b74795d1-11e0-460d-8660-80bf39f1875b"
        data-elfsight-app-lazy
        style={{width:'80%'}}
      ></div>
    </>
  );
};

export default ElfsightGallery;
